/**
 * Utility for input field validation
 */

/**
 * Validates that the input is not empty or whitespace.
 * @param fieldName - The name of the field for the error message.
 * @returns A validation function for Ant Design rules.
 */
export const requiredFieldValidator = (fieldName: string) => {
    return (_: unknown, value: string) => {
      if (!value || value.trim() === "") {
        return Promise.reject(new Error(`Please ${fieldName}`));
      }
      return Promise.resolve();
    };
  };
  